import {PageTemplate} from "../../shared/layout/PageTemplate";
import {DashboardContent} from "./DashboardContent";

export function Dashboard() {
    return <PageTemplate title="Main" pageName="Dashboard" content={<DashboardContent/>}/>

}